module.exports = __webpack_public_path__ + "static/media/tv-outline.1ba19fc5.svg";